import { useEffect, useState } from "react";
import { toastSuccess } from "../../../components/base/Toast";
import Form from "../../../components/form/Form";
import { useHub } from "../../../core/Global";
import User from "../models/User"
import Icon from "../../../components/base/Icon";
import { PaymentTypes } from "../../../core/Enums";
import ToggleSwitch from "../../../components/form/ToggleSwitch";
import FlexRow from "../../../components/base/FlexRow";
import Checkbox from "../../../components/form/Checkbox";

type Props = {
    userId?: string
    model?: User
    onUpdate?: (user: User) => void
}

interface UpdateTechPaymentTypesRequest {
    id?: string
    paymentTypesInherited?: boolean
    techPaymentTypes?: PaymentTypes[]
}

export default function AccountTechPaymentTypes(props: Props) {

    const hub = useHub()
    const [body, bodySet] = useState<UpdateTechPaymentTypesRequest>({})
    const [working, workingSet] = useState<boolean>(false)

    useEffect(() => {
        bodySet({
            ...body,
            id: props.model?.id,
            paymentTypesInherited: props.model?.techPaymentTypesInherited,
            techPaymentTypes: props.model?.techPaymentTypes
        })
    }, [props.model])

    return (
        <Form id="user-techsetting-paymenttypes" className="form"
            onSubmit={(b) => {

                workingSet(true);

                hub.Put("/accounts/technicians/techpaymenttypes", body, res => {
                    if (res.success) {
                        toastSuccess("Technician payment types has been updated successfully!");
                        if (props.onUpdate) props.onUpdate(res.data);
                    }
                    workingSet(false);
                })

            }}>
            <div className="card mb-5 mb-xl-10">
                <div className="card-header border-0">
                    <div className="card-title m-0">
                        <h3 className="fw-bolder m-0">Payment Types</h3>
                    </div>
                    <div className="card-action">
                        <button type="submit" className="btn btn-sm btn-primary" disabled={working}>
                            {
                                working ?
                                    <>
                                        <Icon icon="spinner-third" spin />
                                        <span className="ms-2">Updating...</span>
                                    </>
                                    :
                                    <>
                                        Update Technician
                                    </>
                            }
                        </button>
                    </div>
                </div>

                <div className="card-body border-top p-9"
                    style={{
                        maxWidth: 1000
                    }}>

                    <ToggleSwitch label="Use system payment type settings!"
                        name="paymentTypesInherited" raw small className="mb-5"
                        checked={body.paymentTypesInherited}
                        onChange={e => bodySet({
                            ...body,
                            paymentTypesInherited: e
                        })} />

                    {
                        !body.paymentTypesInherited &&
                        <FlexRow wrap className="bg-light-secondary p-3 pt-5">
                            {
                                Object.entries(PaymentTypes)
                                    .filter(([key, value]) => isNaN(Number(key)) && value !== PaymentTypes.None)
                                    .map(([key, value]) =>
                                        <Checkbox key={`toggle-tech-payment-type-${value}-${key}`}
                                            label={key} className="me-10 mb-5"
                                            checked={body.techPaymentTypes?.includes(value as PaymentTypes)}
                                            onChange={chk => {
                                                bodySet(prev => {
                                                    const list = prev.techPaymentTypes ?? [];
                                                    const type = value as PaymentTypes;
                                                    const next = chk
                                                        ? (list.includes(type) ? list : [...list, type])
                                                        : list.filter(x => x !== type);

                                                    return { ...prev, techPaymentTypes: next };
                                                })
                                            }}
                                        />
                                    )
                            }
                        </FlexRow>
                    }

                </div>

            </div>
        </Form>
    )
}